export default __webpack_public_path__ + "static/media/sipmenu-statement.91e772dd.svg";